<nb-card class="dialog-card dispatch-dialog">
  <nb-card-header>
    <h5>{{ "pages.dozent.participants.dispatchExercise" | translate }}</h5>
  </nb-card-header>
  <nb-card-body>
    <app-page-loader *ngIf="loading"></app-page-loader>

    <ng-container *ngIf="!loading">
      <!-- Exercise picker -->
      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.selectExercise" | translate }} *</label>
        <nb-select
          fullWidth
          placeholder="{{ 'pages.dozent.participants.selectExercisePlaceholder' | translate }}"
          [(selected)]="selectedExerciseId"
        >
          <nb-option *ngFor="let ex of selectableExercises" [value]="ex.id">
            {{ ex.title }} <span class="muted">({{ ex.exercise_type }})</span>
          </nb-option>
        </nb-select>
        <p class="empty-hint" *ngIf="exercises.length === 0">
          {{ "pages.dozent.participants.noOwnExercises" | translate }}
        </p>
        <p class="empty-hint" *ngIf="exercises.length > 0 && !selectedBotIsTwin">
          {{ "pages.dozent.participants.nonTwinAutoOnly" | translate }}
        </p>
      </div>

      <!-- Bot picker (auto-hidden if exactly 1) -->
      <div class="form-group" *ngIf="bots.length > 1">
        <label class="label">{{ "pages.dozent.participants.selectBot" | translate }} *</label>
        <nb-select
          fullWidth
          [selected]="selectedBotId"
          (selectedChange)="onBotSelected($event)"
        >
          <nb-option *ngFor="let b of bots" [value]="b.id">
            <div class="twin-agent-option">
              <span class="twin-agent-option__name">{{ botDisplayName(b) }}</span>
              <span class="twin-agent-option__tags">
                <span class="twin-agent-option__tag">
                  {{ botTypeKey(b) | translate }}
                </span>
                <span class="twin-agent-option__tag" *ngIf="botExternalName(b)">
                  {{ "pages.dozent.participants.externalName" | translate }}:
                  {{ botExternalName(b) }}
                </span>
                <span class="twin-agent-option__tag" *ngIf="botInternalName(b)">
                  {{ "pages.dozent.participants.internalName" | translate }}:
                  {{ botInternalName(b) }}
                </span>
              </span>
            </div>
          </nb-option>
        </nb-select>
      </div>
      <p class="empty-hint" *ngIf="bots.length === 0">
        {{ "pages.dozent.participants.noDozentBots" | translate }}
      </p>

      <!-- Optional fields -->
      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.scheduledPublishAt" | translate }}</label>
        <input nbInput fullWidth type="datetime-local" [(ngModel)]="scheduledPublishAt" />
        <p class="empty-hint">
          {{ "pages.dozent.participants.scheduledPublishAtHint" | translate }}
        </p>
      </div>

      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.dueDate" | translate }}</label>
        <input nbInput fullWidth type="datetime-local" [(ngModel)]="dueDate" />
      </div>

      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.instructionsOptional" | translate }}</label>
        <textarea nbInput fullWidth rows="2" [(ngModel)]="instructions"></textarea>
      </div>

      <!-- Participant multiselect -->
      <div class="form-group">
        <div class="participants-header">
          <label class="label">
            {{ "pages.dozent.participants.selectParticipants" | translate }} *
            <span class="muted">({{ selectedParticipantIds.size }})</span>
          </label>
          <button nbButton size="tiny" ghost (click)="toggleAll()">
            {{ "pages.dozent.participants.selectAll" | translate }}
          </button>
        </div>

        <div class="participant-list">
          <div
            *ngFor="let p of participants"
            class="participant-row"
            [class.disabled]="!isDispatchable(p)"
            [nbTooltip]="!isDispatchable(p) ? ('pages.dozent.participants.notDispatchable' | translate) : ''"
            [nbTooltipDisabled]="isDispatchable(p)"
            (click)="toggleParticipant(p)"
          >
            <nb-checkbox
              [checked]="isDispatchable(p) && selectedParticipantIds.has(p.learner_user_id!)"
              [disabled]="!isDispatchable(p)"
            ></nb-checkbox>
            <span class="name">{{ participantLabel(p) }}</span>
            <span class="email muted" *ngIf="p.email">{{ p.email }}</span>
          </div>
          <p class="empty-hint" *ngIf="participants.length === 0">
            {{ "pages.dozent.participants.noParticipants" | translate }}
          </p>
        </div>
      </div>
    </ng-container>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="!canSubmit()"
      [nbSpinner]="saving"
      nbSpinnerSize="tiny"
      nbSpinnerStatus="control"
    >
      <nb-icon icon="paper-plane-outline" *ngIf="!saving"></nb-icon>
      {{ "pages.dozent.participants.dispatch" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
